export const activatePromoCode = (payload: string) => ({
  type: "@saga/ACTIVATE_PROMOCODE",
  payload,
});
